import { NewWindowAnchor } from '@xo-union/component-standard-elements';
import React, { useRef } from 'react';
import { v4 } from 'uuid';

import styles from './imageUpload.scss';
import { imageFileTypesWithoutGif } from '../../../components/PageItemsRail/ImageField';

const handleUpload = (e: any, onUploadEnded: any): void => {
  const reader = new FileReader();
  const file = e.target.files[0];

  reader.onloadend = (): void => {
    onUploadEnded({
      file,
      imagePreviewUrl: reader.result,
    });
  };

  if (file) {
    reader.readAsDataURL(file);
  }
};

export interface UploadInfo {
  file: any | null;
  imagePreviewUrl: string | ArrayBuffer | null;
}

interface Props {
  onUploadEnded: (info: UploadInfo) => void;
  children: any;
  className?: string;
}

export const ImageUpload: React.FC<Props> = ({ onUploadEnded, children, ...rest }) => {
  const fileId = v4();
  const inputRef = useRef<any>(null);
  const onKeyPress = (e: React.KeyboardEvent): void => {
    if ([' ', 'Enter'].includes(e.key) && inputRef.current) {
      inputRef.current.click();
    }
  };

  return (
    <NewWindowAnchor tabIndex={0} onKeyPress={onKeyPress} {...rest}>
      <label className={`image-upload-label ${styles.upload}`} htmlFor={fileId}>
        {children}
        <input
          ref={inputRef}
          data-testid="image-upload-input"
          type="file"
          id={fileId}
          style={{ display: 'none' }}
          onChange={(e): void => handleUpload(e, onUploadEnded)}
          accept={imageFileTypesWithoutGif.join(',')}
        />
      </label>
    </NewWindowAnchor>
  );
};
